export default __webpack_public_path__ + "static/media/elevate-wht-banner-2.027335f5.jpg";